import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faCheck, faCloud, faTimes } from '@fortawesome/free-solid-svg-icons'

let showIcon = (saving, error) => {
  if (saving)
    return (
      <FontAwesomeIcon
        icon={faCircleNotch}
        size="sm"
        spin
        style={{ color: 'var(--font-resume-section)', fontSize: '0.8em' }}
      />
    )

  if (error)
    return (
      <span className="fa-layers fa-fw">
        <FontAwesomeIcon
          icon={faCloud}
          size="sm"
          style={{ color: 'var(--font-resume-section)', fontSize: '1em' }}
        />
        <FontAwesomeIcon icon={faTimes} size="xs" style={{ color: '#ff7171', fontSize: '0.6em' }} />
      </span>
    )

  return (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon
        icon={faCloud}
        size="sm"
        style={{ color: 'var(--font-resume-section)', fontSize: '1em' }}
      />
      <FontAwesomeIcon
        icon={faCheck}
        size="xs"
        style={{ color: 'var(--main-color)', fontSize: '0.5em' }}
      />
    </span>
  )
}

let showMessage = (saving, error) => {
  if (saving) return <span className="count-down-message">Saving...</span>

  if (error) return <span className="count-down-message">Error.</span>

  return <span className="count-down-message">Saved.</span>
}

const SaveSpinner = ({ saving, error }) => {
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: '35px', textAlign: 'center' }}>{showIcon(saving, error)}</div>
      <div>{showMessage(saving, error)}</div>
    </div>
  )
}

SaveSpinner.defaultProps = { saving: false, error: false }
export default SaveSpinner
